import DataFetch from '../../Utility/data-fetch';

const highlightClass = 'bg-green-100';
const selectionClass = 'selected';

const call = (baseUrl) => {
    return {
        currentPassage: {
            translationCode: '',
            bookCode: '',
            chapterId: 0,
        },
        baseUrl: `${baseUrl}`,
        bookmarks: [],
        showError: false,
        loading: false,
        selectedVerses: [],
        page: 1,
        itemsPerPage: 10,

        async nextPage() {
            if (this.bookmarks && this.bookmarks.length === this.itemsPerPage) {
                this.page += 1;
            }

            await this.getBookmarks(this.page, this.itemsPerPage);
        },

        async prevPage() {
            if (this.page > 1) {
                this.page -= 1;
            }

            await this.getBookmarks(this.page, this.itemsPerPage);
        },

        assignPassage(translationCode, bookCode, chapterId) {
            this.currentPassage = {
                translationCode: translationCode,
                bookCode: bookCode,
                chapterId: chapterId,
            };
        },

        clearSelected() {
            const elems = document.getElementsByClassName('bible-selectable-verse');

            for (let i = 0; i < elems.length; i++) {
                elems[i].classList.remove(highlightClass);
            }
        },

        async getBookmarks() {
            this.loading = true;
            this.bookmarks = [];
            await DataFetch.get(this.baseUrl, {
                params: {
                    page: this.page,
                    itemsPerPage: this.itemsPerPage,
                },
            })
                .then(response => {
                    console.log(response)

                    this.bookmarks = response.data;
                    this.clearSelected();
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },

        async addBookmarks() {
            let verseElems = Array.from(document.getElementsByClassName(`${selectionClass}`));
            this.selectedVerses = verseElems.map((i) => {
                return {
                    translationCode: this.currentPassage.translationCode,
                    bookCode: this.currentPassage.bookCode,
                    chapterId: this.currentPassage.chapterId,
                    verseStart: i.dataset.verseId,
                };
            });

            await DataFetch.post(this.baseUrl, this.selectedVerses)
                .then(async () => {
                    this.page = 1;
                    await this.getBookmarks();
                    this.showError = false;
                })
                .catch(() => {
                    this.showError = true;
                });
        },

        async deleteBookmark(translationCode, bookCode, chapterId, verseId) {
            let result = window.confirm('Are you sure you wish to delete this bookmark?');
            if (!result) {
                return;
            }

            return await DataFetch.remove(`${this.baseUrl}`, {
                data: {
                    translationCode: translationCode,
                    bookCode: bookCode,
                    chapterId: chapterId,
                    verseStart: verseId,
                },
            }).then(async () => {
                await this.getBookmarks();
            });
        },
    };
};

export default call;